import { fontFamilies, fontSize, unitlessFontSize, fontLineHeight, unitlessFontLineHeight, mediaQueryVals } from '../../shared/common';

// reverted to Oct 16, 2024 
export const typography = {
  // Display Book 01
  'h1, .cpsd-display-roman-book-01': `font-family: ${fontFamilies.recklessXPD};
            font-size: ${fontSize.fontSize01};
            font-size: clamp(57px, calc((${unitlessFontSize.fontSize01} / 1440)* 100vw), 75px);
            line-height: ${fontLineHeight.fontLineHeight01};
            line-height: clamp(60px, calc((${unitlessFontLineHeight.fontLineHeight01} / 1440)* 100vw), 79px);
            letter-spacing: -0.01em;            
            font-weight: 250; 
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
                  font-family: ${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize03};
                  line-height: ${fontLineHeight.fontLineHeight03};
                  letter-spacing: -0.01em;                  
                  font-weight: 250;
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/roman/book-01;
                  font-family: ${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize03};
                  line-height: ${fontLineHeight.fontLineHeight03};
                  letter-spacing: -0.01em;                  
                  font-weight: 250;
            }
			`,
  '.cpsd-display-italics-book-01': `//styleName: desktop-typography/display/roman/book-01;
            font-family: ${fontFamilies.recklessXPD};
            font-size: ${fontSize.fontSize01};
            font-size: clamp(57px, calc((${unitlessFontSize.fontSize01} / 1440)* 100vw), 75px);
            line-height: ${fontLineHeight.fontLineHeight01};
            line-height: clamp(60px, calc((${unitlessFontLineHeight.fontLineHeight01} / 1440)* 100vw), 79px);
            letter-spacing: -0.01em;                        
            font-weight: 300;
            font-style: italic;
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
                  //styleName: tablet-typography/display/roman/book-01;
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize03};
                        line-height: ${fontLineHeight.fontLineHeight03};
                        letter-spacing: -0.01em;                              
                        font-weight: 300;
                        font-style: italic;
                  }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/roman/book-01;
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize03};
                        line-height: ${fontLineHeight.fontLineHeight03};
                        letter-spacing: -0.01em;                              
                        font-weight: 300;
                        font-style: italic;
                  }
      `,
  '.cpds-display-numeral-bold-01': `font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize01};
            font-size: clamp(57px, calc((${unitlessFontSize.fontSize01} / 1440)* 100vw), 75px);
            font-weight: 700;
            line-height: ${fontLineHeight.fontLineHeight01};
            line-height: clamp(60px, calc((${unitlessFontLineHeight.fontLineHeight01} / 1440)* 100vw), 79px);
            letter-spacing: -0.01em;
                        
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
            //styleName: tablet-typography/display/numeral/bold-01;
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize03};
                  font-weight: 700;
                  line-height: ${fontLineHeight.fontLineHeight03};
                  letter-spacing: -0.01em;
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/numerals/bold-01;
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize03};
                  font-weight: 700;
                  line-height: ${fontLineHeight.fontLineHeight03};
                  letter-spacing: -0.01em;
            }
      `,

  // Display Book 02
  'h2, .cpds-display-roman-book-02': `font-family: ${fontFamilies.recklessXPD};
            font-size: ${fontSize.fontSize02};
            font-size: clamp(50px, calc((${unitlessFontSize.fontSize02} / 1440)* 100vw), 65px);
            line-height: ${fontLineHeight.fontLineHeight02};
            line-height: clamp(57px, calc((${unitlessFontLineHeight.fontLineHeight02} / 1440)* 100vw), 75px);
            letter-spacing: -0.03em;            
            font-weight: 250;
           @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
                  //styleName: tablet-typography/display/roman/book-02;
                  font-family: ${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize04};
                  line-height: ${fontLineHeight.fontLineHeight04};
                  letter-spacing: -0.03em;                  
                 font-weight: 250;
            }
           @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/roman/book-02;
                  font-family: ${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize04};
                  line-height: ${fontLineHeight.fontLineHeight04};
                  letter-spacing: -0.03em;                  
                  font-weight: 250;
            }
      `,
  'h2 i, h2 em, .cpds-display-italics-book-02': `//styleName: desktop-typography/display/roman/book-02;
                  font-family: ${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize02};
                  font-size: clamp(50px, calc((${unitlessFontSize.fontSize02} / 1440)* 100vw), 65px);
                  line-height: ${fontLineHeight.fontLineHeight02};
                  line-height: clamp(57px, calc((${unitlessFontLineHeight.fontLineHeight02} / 1440)* 100vw), 75px);
                  letter-spacing: -0.03em;                              
                  font-weight: 250;
                  font-style: italic;
									@media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
									//styleName: tablet-typography/display/roman/book-02;
												font-family:  ${fontFamilies.recklessXPD};
												font-size: ${fontSize.fontSize04};
												line-height: ${fontLineHeight.fontLineHeight04};
												letter-spacing: -0.03em;                              
												font-weight: 250;
												font-style: italic;
									}
									@media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
									//styleName: mobile-typography/display/roman/book-02;
												font-family:  ${fontFamilies.recklessXPD};
												font-size: ${fontSize.fontSize04};
												line-height: ${fontLineHeight.fontLineHeight04};
												letter-spacing: -0.03em;                              
												font-weight: 250;
												font-style: italic;
									}
      `,
  'h2 b, h2 strong, .cpds-display-numeral-bold-02': `font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize02};
            font-size: clamp(50px, calc((${unitlessFontSize.fontSize02} / 1440)* 100vw), 65px);
            font-weight: 700;
            line-height: ${fontLineHeight.fontLineHeight02};
            line-height: clamp(57px, calc((${unitlessFontLineHeight.fontLineHeight02} / 1440)* 100vw), 75px);
            letter-spacing: -0.03em;                        
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                              
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize04};
                  font-weight: 700;
                  line-height: ${fontLineHeight.fontLineHeight04};
                  letter-spacing: -0.03em;
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                  
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize04};
                  font-weight: 700;
                  line-height: ${fontLineHeight.fontLineHeight04};
                  letter-spacing: -0.03em;
            }
      `,

  // Display Book 03
  'h3, .cpds-display-roman-book-03': `//styleName: desktop-typography/display/roman/book-03;
            font-family: ${fontFamilies.recklessXPD};
            font-size: ${fontSize.fontSize03};
            line-height: ${fontLineHeight.fontLineHeight03};
            letter-spacing: -0.01em;            
            font-weight: 300;
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
                  //styleName: tablet-typography/display/roman/book-03;
                  font-family: ${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize05};
                  line-height: ${fontLineHeight.fontLineHeight05};
                  letter-spacing: -0.01em;                  
                  font-weight: 300;
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/roman/book-03;
                  font-family: ${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize06};
                  line-height: ${fontLineHeight.fontLineHeight06};
                  letter-spacing: -0.01em;                  
                  font-weight: 300;
            }
      `,
  '.cpds-display-italics-book-03': `//styleName: desktop-typography/display/roman/book-03;
            font-family: ${fontFamilies.recklessXPD};
            font-size: ${fontSize.fontSize03};
            line-height: ${fontLineHeight.fontLineHeight03};
            letter-spacing: -0.01em;                        
            font-weight: 250;
            font-style: italic;
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
                  //styleName: tablet-typography/display/roman/book-03;
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize05};
                        line-height: ${fontLineHeight.fontLineHeight05};
                        letter-spacing: -0.01em;                              
                        font-weight: 250;
                        font-style: italic;
                  }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/roman/book-03;
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize06};
                        line-height: ${fontLineHeight.fontLineHeight06};
                        letter-spacing: -0.01em;                              
                        font-weight: 250;
                        font-style: italic;
                  }
      `,
  '.cpds-display-numeral-bold-03': `font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize03};
            font-weight: 700;
            line-height: ${fontLineHeight.fontLineHeight03};
            letter-spacing: -0.01em;
                        
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
            //styleName: tablet-typography/display/numeral/bold-03;
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize05};
                  font-weight: 700;
                  line-height: ${fontLineHeight.fontLineHeight05};
                  letter-spacing: -0.01em;
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/numerals/bold-03;
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize06};
                  font-weight: 700;
                  line-height: ${fontLineHeight.fontLineHeight06};
                  letter-spacing: -0.01em;
            }
      `,

  // Display Book 04
  'h4, .cpds-display-roman-book-04': `//styleName: desktop-typography/display/roman/book-04;
            font-family: ${fontFamilies.recklessXPD};
            font-size: ${fontSize.fontSize04};
            line-height: ${fontLineHeight.fontLineHeight04};
            letter-spacing: -0.01em;                        
            font-weight: 250;
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
                        //styleName: tablet-typography/display/roman/book-04;
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize06};
                        line-height: ${fontLineHeight.fontLineHeight06};
                        letter-spacing: -0.01em;                              
                        font-weight: 250;
                  }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                        //styleName: mobile-typography/display/roman/book-04;
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize08};
                        line-height: ${fontLineHeight.fontLineHeight08};
                        letter-spacing: -0.01em;                              
                        font-weight: 250;
                  }
      `,
  '.cpds-display-italics-book-04': `//styleName: desktop-typography/display/roman/book-04;
            font-family: ${fontFamilies.recklessXPD};
            font-size: ${fontSize.fontSize04};
            line-height: ${fontLineHeight.fontLineHeight04};
            letter-spacing: -0.01em;                        
            font-weight: 300;
            font-style: italic;
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
                  //styleName: tablet-typography/display/roman/book-04;
                  font-family:${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize06};
                  line-height: ${fontLineHeight.fontLineHeight06};
                  letter-spacing: -0.01em;                              
                  font-weight: 300;
                  font-style: italic;
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/roman/book-04;
                  font-family:${fontFamilies.recklessXPD};
                  font-size: ${fontSize.fontSize08};
                  line-height: ${fontLineHeight.fontLineHeight08};
                  letter-spacing: -0.01em;                              
                  font-weight: 300;
                  font-style: italic;
            }
      `,
  '.cpds-display-numeral-bold-04': `font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize04};
            font-weight: 700;
            line-height: ${fontLineHeight.fontLineHeight04};
            letter-spacing: -0.01em;
                        
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
            //styleName: tablet-typography/display/numeral/bold-01;
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize06};
                  font-weight: 700;
                  line-height: ${fontLineHeight.fontLineHeight06};
                  letter-spacing: -0.01em;
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                  //styleName: mobile-typography/display/numerals/bold-01;
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize08};
                  font-weight: 700;
                  line-height: ${fontLineHeight.fontLineHeight08};
                  letter-spacing: -0.01em;
            }
      `,

  // Heading Book 05
  'h5, .cpds-heading-roman-book-05': `//styleName: desktop-typography/heading/roman/book-05;
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize06};
                        line-height: ${fontLineHeight.fontLineHeight05};
                        letter-spacing: -0.01em;                        
                        font-weight: 250;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                                
                              font-family: ${fontFamilies.recklessXPD};
                              font-size: ${fontSize.fontSize07};
                              line-height: ${fontLineHeight.fontLineHeight07};
                              letter-spacing: -0.01em;                              
                              font-weight: 250;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                             
                              font-family: ${fontFamilies.recklessXPD};
                              font-size: ${fontSize.fontSize08};
                              line-height: ${fontLineHeight.fontLineHeight08};
                              letter-spacing: -0.01em;                              
                              font-weight: 250;
                        }
      `,
  '.cpds-heading-italics-book-05': `
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize06};
                        line-height: ${fontLineHeight.fontLineHeight04};
                        letter-spacing: -0.01em;                        
                        font-weight: 300;
                        font-style: italic;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                                
                              font-family: ${fontFamilies.recklessXPD};
                              font-size: ${fontSize.fontSize07};
                              line-height: ${fontLineHeight.fontLineHeight07};
                              letter-spacing: -0.01em;                              
                              font-weight: 300;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                             
                              font-family: ${fontFamilies.recklessXPD};
                              font-size: ${fontSize.fontSize08};
                              line-height: ${fontLineHeight.fontLineHeight08};
                              letter-spacing: -0.01em;                              
                              font-weight: 300;
                        }
      `,

  // Heading Med 05
  '.cpds-heading-roman-med-05': `//styleName: desktop-typography/heading/med/book-05;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize06};
                        line-height: ${fontLineHeight.fontLineHeight05};
                        letter-spacing: -0.01em;                        
                        font-weight: 500;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize07};
                              line-height: ${fontLineHeight.fontLineHeight07};
                              letter-spacing: -0.01em;                              
                              font-weight: 500;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                              
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize08};
                              line-height: ${fontLineHeight.fontLineHeight08};
                              letter-spacing: -0.01em;                              
                              font-weight: 500;
                        }
      `,
  '.cpds-heading-italics-med-05': `
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize06};
                        line-height: ${fontLineHeight.fontLineHeight04};
                        letter-spacing: -0.01em;                        
                        font-weight: 500;
                        font-style: italic;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize07};
                              line-height: ${fontLineHeight.fontLineHeight07};
                              letter-spacing: -0.01em;                              
                              font-weight: 500;
                              font-style: italic;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                              
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize08};
                              line-height: ${fontLineHeight.fontLineHeight08};
                              letter-spacing: -0.01em;                              
                              font-weight: 500;
                              font-style: italic;
                        }
      `,

  // Heading Book 06
  'h6, .cpds-heading-roman-book-06': `
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize07};
                        line-height: ${fontLineHeight.fontLineHeight06};
                        letter-spacing: -0.01em;                        
                        font-weight: 250;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.recklessXPD};
                              font-size: ${fontSize.fontSize08};
                              line-height: ${fontLineHeight.fontLineHeight08};
                              letter-spacing: -0.01em;                              
                              font-weight: 250;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                             
                              font-family: ${fontFamilies.recklessXPD};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight08};
                              letter-spacing: -0.01em;                              
                              font-weight: 250;
                        }
      `,
  '.cpds-heading-italics-book-06': `//styleName: desktop-typography/heading/roman/book-06;
                        font-family: ${fontFamilies.recklessXPD};
                        font-size: ${fontSize.fontSize07};
                        line-height: ${fontLineHeight.fontLineHeight06};
                        letter-spacing: -0.01em;                        
                        font-weight: 250;
                        font-style: italic;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.recklessXPD};
                              font-size: ${fontSize.fontSize08};
                              line-height: ${fontLineHeight.fontLineHeight08};
                              letter-spacing: -0.01em;                              
                              font-weight: 250;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                             
                              font-family: ${fontFamilies.recklessXPD};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight08};
                              letter-spacing: -0.01em;                              
                              font-weight: 250;
                        }
      `,

  // Heading Med 06
  '.cpds-heading-roman-med-06': `
            font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize07};
            line-height: ${fontLineHeight.fontLineHeight06};
            letter-spacing: -0.01em;                        
            font-weight: 500;
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                    
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize08};
                  line-height: ${fontLineHeight.fontLineHeight08};
                  letter-spacing: -0.01em;                              
                  font-weight: 500;
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                 
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize09};
                  line-height: ${fontLineHeight.fontLineHeight08};
                  letter-spacing: -0.01em;                              
                  font-weight: 500;
            }
      `,
  '.cpds-heading-italics-med-06': `//styleName: desktop-typography/heading/roman/book-05;
            font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize07};
            line-height: ${fontLineHeight.fontLineHeight06};
            letter-spacing: -0.01em;                        
            font-weight: 500;
            font-style: italic;
            @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                                    
                  font-size: ${fontSize.fontSize08};
                  line-height: ${fontLineHeight.fontLineHeight08};                  
            }
            @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                 
                  font-size: ${fontSize.fontSize09};
                  line-height: ${fontLineHeight.fontLineHeight08};                  
            }
      `,

  // Body Book 07
  'p, .cpds-body-roman-book-07': `
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize08};
                        line-height: ${fontLineHeight.fontLineHeight06};                        
                        font-weight: 400;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 400;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                             //styleName: mobile-typography/body/roman/book-07;
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 400;
                        }
                        &[data-font="psmall"]{
                              font-family: ${fontFamilies.centraNo2}; 
                              font-size: 16px; 
                              font-weight: 300; 
                              line-height: 24px; 
                              letter-spacing: 0;
                              @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit})
                              {
                                    font-family: ${fontFamilies.centraNo2}; font-size: 14px; font-weight: 500; line-height: 20 px;letter-spacing: 0;
                              }
                        }
      `,
  '.cpds-body-roman-book-underlined-07': `
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize08};
                        line-height: ${fontLineHeight.fontLineHeight06};                        
                        font-weight: 400;
                        text-decoration: underline;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 400;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                             //styleName: mobile-typography/body/roman/book-07;
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 400;
                        }
                        &[data-font="psmall"]{
                              font-family: ${fontFamilies.centraNo2}; 
                              font-size: 16px; 
                              font-weight: 300; 
                              line-height: 24px; 
                              letter-spacing: 0;
                              @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit})
                              {
                                    font-family: ${fontFamilies.centraNo2}; font-size: 14px; font-weight: 500; line-height: 20 px;letter-spacing: 0;
                              }
                        }
      `,
  '.cpds-body-italics-book-07': `//styleName: desktop-typography/body/italics/book-07;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize08};
                        line-height: ${fontLineHeight.fontLineHeight07};                        
                        font-weight: 400;
                        font-style: italic;                        
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 400;
                        }
                       @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                            
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 400;
                        }
      `,
  '.cpds-body-roman-medium-07': `//styleName: desktop-typography/body/roman/med-07;
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize08};
                  line-height: ${fontLineHeight.fontLineHeight06};                  
                  font-weight: 500;
                  @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 500;
                        }
                  @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                              
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 500;
                        }
      `,
  '.cpds-body-italics-med-07': `
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize08};
                  line-height: ${fontLineHeight.fontLineHeight07};                  
                  font-weight: 500;
                  font-style: italic;
                  @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 500;
                        }
                  @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                              
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize09};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 500;
                        }
      `,

  // Body Book 08
  '.paracontentsm, .cpds-body-roman-book-08': `//styleName: desktop-typography/body/roman/book-08;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize09};
                        line-height: ${fontLineHeight.fontLineHeight07};                        
                        font-weight: 400;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                              
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 400;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                           
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 400;
                        }
      `,
  '.cpds-body-roman-book-underlined-08': `
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize09};
                        line-height: ${fontLineHeight.fontLineHeight07};                        
                        font-weight: 400;
                        text-decoration: underline;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                              
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 400;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                           
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 400;
                        }
      `,
  '.cpds-body-italics-book-08': `//styleName: desktop-typography/body/italics/book-08;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize09};
                        line-height: ${fontLineHeight.fontLineHeight07};                        
                        font-weight: 400;
                        font-style: italic;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 400;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                           
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 400;
                        }
      `,
  '.cpds-body-roman-medium-08': `//styleName: desktop-typography/body/roman/med-08;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize09};
                        line-height: ${fontLineHeight.fontLineHeight07};                        
                        font-weight: 500;
                        @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 500;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                            
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 500;
                        }
      `,
  '.cpds-body-italics-med-08': `
                  font-family: ${fontFamilies.centraNo2};
                  font-size: ${fontSize.fontSize09};
                  line-height: ${fontLineHeight.fontLineHeight07};                  
                  font-weight: 500;
                  font-style: italic;
                  @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                                               
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 500;
                        }
                  @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				                              
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize10};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 500;
                        }
      `,

  // Meta Book 09
  '.metastyle, .cpds-meta-roman-book-09': `//styleName: global-typography/meta/roman/book-09;
            font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize11};
            line-height: ${fontLineHeight.fontLineHeight09};                        
            font-weight: 400;                        
      `,
  '.cpds-meta-italics-book-09': `//styleName: global-typography/meta/italics/book-09;
            font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize11};
            line-height: ${fontLineHeight.fontLineHeight09};                           
            font-weight: 400;
            font-style: italic;                   
      `,
  '.cpds-meta-roman-medium-book-09': `//styleName: global-typography/meta/roman/med-09;
            font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize11};
            line-height: ${fontLineHeight.fontLineHeight09};                           
            font-weight: 500;         
      `,
  '.cpds-meta-italics-med-book-09': `//styleName: global-typography/meta/roman/med-09;
            font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize11};
            line-height: ${fontLineHeight.fontLineHeight09};                           
            font-weight: 500;
            font-style: italic;         
      `,

  // Meta Book 10
  '.metastyleSmall, .cpds-meta-roman-book-10': `//styleName: global-typography/meta/roman/book-10;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize12};
                        line-height: ${fontLineHeight.fontLineHeight10};                            
                        font-weight: 400;                    
      `,
  '.cpds-meta-roman-book-caps-10': `//styleName: global-typography/meta/roman/book-10;
            font-family: ${fontFamilies.centraNo2};
            font-size: ${fontSize.fontSize12};
            line-height: ${fontLineHeight.fontLineHeight10};                            
            font-weight: 400;
            text-transform: uppercase;                    
      `,
  '.cpds-meta-italics-book-10': `//styleName: global-typography/meta/italics/book-10;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize12};
                        line-height: ${fontLineHeight.fontLineHeight10};                        
                        font-weight: 400;
                        font-style: italic;
                        
      `,
  '.cpds-meta-italics-book-caps-10': `//styleName: global-typography/meta/italics/book-10;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize12};
                        line-height: ${fontLineHeight.fontLineHeight10};                        
                        font-weight: 400;
                        text-transform: uppercase;
                        font-style: italic;
      `,

  '.cpds-meta-roman-medium-book-10': `//styleName: global-typography/meta/roman/med-10;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize12};
                        line-height: ${fontLineHeight.fontLineHeight10};                        
                        font-weight: 500;                             
      `,
  '.cpds-meta-roman-medium-caps-10': `//styleName: global-typography/meta/roman/med-10;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize12};
                        line-height: ${fontLineHeight.fontLineHeight10};                        
                        font-weight: 500;  
                        text-transform: uppercase;      
      `,
  '.cpds-meta-italics-medium-10': `//styleName: global-typography/meta/italics/book-10;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize12};
                        line-height: ${fontLineHeight.fontLineHeight10};                        
                        font-weight: 500;
                        
      `,
  '.cpds-meta-italics-medium-caps-10': `//styleName: global-typography/meta/italics/book-10;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize12};
                        line-height: ${fontLineHeight.fontLineHeight10};                        
                        font-weight: 500;
                        font-style: italic;
                        
      `,

  '.cpds-body-roman-medium-05': `//styleName: desktop-typography/heading/roman/med-05;
                        font-family: ${fontFamilies.centraNo2};
                        font-size: ${fontSize.fontSize06};
                        line-height: ${fontLineHeight.fontLineHeight05};                        
                        font-weight: 300;
                        letter-spacing: -0.01em;

                       @media only screen and (max-width:${mediaQueryVals?.cpds_medium_upper_limit}){                  
                             //styleName: tablet-typography/body/roman/med-08;
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize07};
                              line-height: ${fontLineHeight.fontLineHeight07};                              
                              font-weight: 300;
                              letter-spacing: -0.01em;
                        }
                        @media only screen and (max-width:${mediaQueryVals?.cpds_small_upper_limit}){				
                            //styleName: mobile-typography/body/roman/med-08;
                              font-family: ${fontFamilies.centraNo2};
                              font-size: ${fontSize.fontSize08};
                              line-height: ${fontLineHeight.fontLineHeight08};                              
                              font-weight: 300;
                              letter-spacing: -0.01em;
                        }
      `,

  '.cpds-heading-roman-book-lite-06': `font-family: ${fontFamilies.recklessXPD}; font-size: 21px; font-weight: 300; line-height: 26px; letter-spacing: -1%;
        @media only screen and (max-width: ${mediaQueryVals?.cpds_small_upper_limit}){
        font-family: ${fontFamilies.recklessXPD}; font-size: 16px; font-weight: 300; line-height: 20px; letter-spacing: -1%;}`,
  '.paracontent': `font-family: ${fontFamilies.centraNo2}; font-size: 18px; font-weight: 300; line-height: 26px; letter-spacing: 0;
						@media only screen and (max-width: ${mediaQueryVals?.cpds_small_upper_limit}){
						font-family: ${fontFamilies.centraNo2}; font-size: 16px; font-weight: 500; line-height: 24 px; letter-spacing: 0;}`,
  '.paracontent-medium': `font-family: ${fontFamilies.centraNo2}; font-size: 18px; font-weight: 400; line-height: 28px; letter-spacing: 0;
								@media only screen and (max-width: ${mediaQueryVals?.cpds_small_upper_limit}){
								font-family: ${fontFamilies.centraNo2}; font-size: 16px; font-weight: 400; line-height: 28 px; letter-spacing: 0;}`,
  '.videometatypo, .cpds-videometa-roman-book-14': `font-family: ${fontFamilies.recklessXPD}; font-size: 12px; font-weight: 300; line-height: 14px; letter-spacing: 0;`,
  '.cpds-videoplaybackmeta-roman-book-11': `font-family: ${fontFamilies.centraNo2}; font-size: 8px; font-weight: 400; line-height: normal; letter-spacing: 0;`,
  //meta font variations
  //Desktop
  meta_09_medium_normal:
    'font-family: Centra No2; font-size: 12px; font-weight: 500; line-height: 16px; letter-spacing: 0;',
  meta_10_normal_normal:
    'font-family: Centra No2; font-size: 10px; font-weight: 400; line-height: 12px; letter-spacing: 0;',
  meta_10_medium_normal:
    'font-family: Centra No2; font-size: 10px; font-weight: 500; line-height: 12px; letter-spacing: 0;',
};